import {
	appealsCollectiveConstants
}from './constants'
import api from './api'
import {
	defAction
}from '../../../../helpers/defaultAction'

export const appealsCollectiveActions = {
	GetCollectiveAppeals,
	ClearGetCollectiveAppeals,
	GetApplicants,
	JoinToCollectiveAppeal,
	SubmitAppeal,
	InviteUserToAppeal,
	DeclineInvitation,
	CheckUserExistInAppeal,
	ClearCollectiveActions,
	GetInvitedUsers,
	CheckUserHaveInvite,
	ClearInviteResult,
	GetPendnigAppealData,
	PendnigAppealDataClear,
	GetOrgApplicants,
	ClearSubmitCollectiveActions,
	GetOrgCollectiveAppealUserList,
	ClearGetOrgCollectiveAppealUserList
}

function GetCollectiveAppeals(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetCollectiveAppeals,
		service   : {
			func   : api.GetCollectiveAppeals,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function ClearGetCollectiveAppeals(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.GetCollectiveAppeals.CLEAR
	})
}

function ClearSubmitCollectiveActions(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.SubmitAppeal.CLEAR
	})
}
function ClearCollectiveActions(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.JoinToCollectiveAppeal.CLEAR
	})
}

function ClearInviteResult(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.InviteUserToAppeal.CLEAR
	})
}

function ClearGetOrgCollectiveAppealUserList(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.GetOrgCollectiveAppealUserList.CLEAR
	})
}

function GetApplicants(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetAppealUsers,
		service   : {
			func   : api.GetCollectiveAppealUsers,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function GetOrgApplicants(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetOrgAppealUsers,
		service   : {
			func   : api.GetOrgCollectiveAppealUsers,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function GetOrgCollectiveAppealUserList(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetOrgCollectiveAppealUserList,
		service   : {
			func   : api.GetOrgCollectiveAppealUserList,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function JoinToCollectiveAppeal(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.JoinToCollectiveAppeal,
		service   : {
			func   : api.JoinToCollectiveAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function SubmitAppeal(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.SubmitAppeal,
		service   : {
			func   : api.SubmitAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function InviteUserToAppeal(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.InviteUserToAppeal,
		service   : {
			func   : api.InviteUserToAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function DeclineInvitation(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.DeclineInvitation,
		service   : {
			func   : api.DeclineInvitation,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function CheckUserExistInAppeal(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.CheckUserExistInAppeal,
		service   : {
			func   : api.CheckUserExistInAppeal,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function GetInvitedUsers(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetInvitedUsers,
		service   : {
			func   : api.GetInvitedUsers,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function CheckUserHaveInvite(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.CheckUserHaveInvite,
		service   : {
			func   : api.CheckUserHaveInvite,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function GetPendnigAppealData(params){
	const dispatchObj = {
		constants : appealsCollectiveConstants.GetPendnigAppealData,
		service   : {
			func   : api.GetPendnigAppealData,
			params : params
		}
	}

	return defAction(dispatchObj)
}

function PendnigAppealDataClear(){
	return (dispatch) => dispatch({
		type: appealsCollectiveConstants.GetPendnigAppealData.CLEAR
	})
}